import { onDocumentLoaded, updateAllHeaderCustomProperties } from '@theme/utilities';

onDocumentLoaded(() => {
  updateAllHeaderCustomProperties();
});
